import { lazy, Suspense } from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { AuthProvider } from "./hooks/useAuth.js";
import { Layout } from "./components/Layout.js";
import { ErrorBoundary } from "./components/ErrorBoundary.js";

const Home = lazy(() => import("./pages/Home.js").then(m => ({ default: m.Home })));
const Login = lazy(() => import("./pages/Login.js").then(m => ({ default: m.Login })));
const Search = lazy(() => import("./pages/Search.js").then(m => ({ default: m.Search })));
const CardDetail = lazy(() => import("./pages/CardDetail.js").then(m => ({ default: m.CardDetail })));
const AddCard = lazy(() => import("./pages/AddCard.js").then(m => ({ default: m.AddCard })));
const Collection = lazy(() => import("./pages/Collection.js").then(m => ({ default: m.Collection })));
const CollectionEdit = lazy(() => import("./pages/CollectionEdit.js").then(m => ({ default: m.CollectionEdit })));
const Marketplace = lazy(() => import("./pages/Marketplace.js").then(m => ({ default: m.Marketplace })));
const MyProposals = lazy(() => import("./pages/MyProposals.js").then(m => ({ default: m.MyProposals })));
const Wishlist = lazy(() => import("./pages/Wishlist.js").then(m => ({ default: m.Wishlist })));
const Settings = lazy(() => import("./pages/Settings.js").then(m => ({ default: m.Settings })));
const Analytics = lazy(() => import("./pages/Analytics.js").then(m => ({ default: m.Analytics })));
const Achievements = lazy(() => import("./pages/Achievements.js").then(m => ({ default: m.Achievements })));
const Pricing = lazy(() => import("./pages/Pricing.js").then(m => ({ default: m.Pricing })));
const PublicCollection = lazy(() => import("./pages/PublicCollection.js").then(m => ({ default: m.PublicCollection })));
const Privacy = lazy(() => import("./pages/Privacy.js").then(m => ({ default: m.Privacy })));

function PageLoader() {
  return (
    <div className="flex items-center justify-center min-h-[50vh]">
      <div className="w-10 h-10 border-2 border-brand-yellow/30 border-t-brand-yellow rounded-full animate-spin" />
    </div>
  );
}

export function App() {
  return (
    <ErrorBoundary>
    <BrowserRouter>
      <AuthProvider>
        <Layout>
          <Suspense fallback={<PageLoader />}>
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/login" element={<Login />} />
            <Route path="/search" element={<Search />} />
            <Route path="/card/:id" element={<CardDetail />} />
            <Route path="/add" element={<AddCard />} />
            <Route path="/add/:cardId" element={<AddCard />} />
            <Route path="/collection" element={<Collection />} />
            <Route path="/collection/:id/edit" element={<CollectionEdit />} />
            <Route path="/marketplace" element={<Marketplace />} />
            <Route path="/proposals" element={<MyProposals />} />
            <Route path="/wishlist" element={<Wishlist />} />
            <Route path="/settings" element={<Settings />} />
            <Route path="/analytics" element={<Analytics />} />
            <Route path="/achievements" element={<Achievements />} />
            <Route path="/pricing" element={<Pricing />} />
            <Route path="/u/:username" element={<PublicCollection />} />
            <Route path="/privacy" element={<Privacy />} />
          </Routes>
          </Suspense>
        </Layout>
      </AuthProvider>
    </BrowserRouter>
    </ErrorBoundary>
  );
}
